import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";

@Component({
    selector: 'app-email-change-confirmation',
    standalone: true,
    imports: [MatButtonModule,MatDialogModule, MatDialogContent],
    templateUrl: './email-change-confirmation.component.html',
    styleUrl: './email-change-confirmation.component.scss'
})
export class EmailChangeConfirmation{
    constructor(private dialogRef: MatDialogRef<ConfirmationDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: { message: string }) {}

    onSuccessResponse() {
        this.dialogRef.close(true); 
    }

    onNegativeResponse() {
        this.dialogRef.close();
    }
}